import React, { useRef } from 'react';
var VeltNotificationsPanelContentAllListItemLabel = function (props) {
    var date = props.date, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-all-list-item-label", { ref: ref, date: date, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelContentAllListItemLabel;
